import { SxProps, Theme } from '@mui/material';

const classes = {
  notes: {
    mb: 10,
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
